<template>
    <div class="row">

        <div class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/auctions-list/Completed/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.completed_auction"
                                   title="Completed Auctions" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-1.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div v-if="currentUser.is_bank_admin || currentUser.is_superuser
            || currentUser.is_ventura_admin || currentUser.permission.can_view_live_auction"
             class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/live-auction/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.on_going_auctions"
                                   title="Live Auctions" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-2.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div v-else class="col-lg-3 col-12 col-md-6 mt-3">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.on_going_auctions"
                                   title="Live Auctions" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-2.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/banks-list/Active/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.active_bank"
                                   title="Active Bank/FI’s" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-3.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/banks-list/Inactive/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.inactive_bank"
                                   title="Suspended Bank/FI’s" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-4.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/manage-users/0/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.admin_users"
                                   title="Admin Users" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-5.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/manage-users/0/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.bank_users"
                                   title="Bank/FI Users" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-6.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div v-if="currentUser.is_bank_admin || currentUser.is_superuser
            || currentUser.is_ventura_admin || currentUser.permission.can_view_bidder"
             class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/bidders-list/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.bidders"
                                   title="Bidders" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-7.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div v-else class="col-lg-3 col-12 col-md-6 mt-3">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.bidders"
                                   title="Bidders" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-7.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

        <div class="col-lg-3 col-12 col-md-6 mt-3" @click="$router.push('/drafted-auctions-list/')">
            <custom-dashboard-stat size="xs" design="basic-b" :border="true" text-align="center"
                                   :serial="auctionData.drafted_auctions"
                                   title="Drafted Auctions" content="">
                <template #pre>
                    <img src="../../../assets/web/super-admin/dashboard/widget-8.png" class="icon-md" alt="">
                </template>
            </custom-dashboard-stat>
        </div>

    </div>
</template>

<script>
import CustomDashboardStat from '@components/dashboard/CustomDashboardStat';
import axios from 'secure-axios';
import urls from '../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'AdminDashboardStatsSection',
    computed : {
        ...mapGetters(['currentUser'])
    },

    components : { CustomDashboardStat },

    data () {
        return {
            auctionData : []
        };
    },

    mounted () {
        this.loadDetails();
    },

    methods : {

        async loadDetails () {
            const response = await axios.get(urls.auth.dashboard);

            if (response.data.success) {
                this.auctionData = response.data.data;
            } else {
                this.$notify('Could not load data, Please try again later', 'Error', {
                    type : 'danger'
                });
            }
        }

    }
};
</script>

<style scoped>

</style>
